import { useCallback } from "react";

import { execAction } from "@/lib/executeServerAction";
import { clientApi } from "@/actions";

import { usePaymentSystemStore } from "../domain/store";
import { PayOptions } from "../domain/types";

//

export function usePaymentSystem() {
  const paymentsApi = usePaymentSystemStore((s) => s.paymentModalApi);

  //

  const verifyCard = useCallback(async () => {
    const invoice = await execAction(clientApi.invoice.createPaymentCardLinkingInvoice);
    const data = await paymentsApi.createChargeModal({ invoice });
    return data;
  }, [paymentsApi]);

  //

  const charge = useCallback(
    async (options: PayOptions) => {
      return await paymentsApi.createChargeModal(options);
    },
    [paymentsApi],
  );

  //

  return { verifyCard, charge };
}
